const eventSpacesFunctions = () => {
    $(document).on('click', '.js-event-space-cotnent-trigger', function(e) {
        e.preventDefault();

        $(this).stop().toggleClass('open');
        $(this).next('.event-spaces__row').stop().slideToggle();
    });

    $(document).on('click', '.js-event-spaces-space-toggle', function(e) {
        e.preventDefault();

        const slideIndex = $(this).data('slide-index');

        $('.event-spaces__navigation-item').removeClass('active');
        $(this).addClass('active');
        $('.js-event-spaces-space-slider').slick('slickGoTo', slideIndex, false);
    });
};
